import * as React from "react";
import { toLocalDateTime} from "../../../../../HelperMethods";

//Add this method to calculate duration between two times
export const calculateDuration = (startTime: Date, endTime: Date): number => {
    try {
      // Get hours difference
      const diffInMilliseconds = endTime.getTime() - startTime.getTime();
      const diffInHours = diffInMilliseconds / (1000 * 60 * 60);
      // Round to 2 decimal places
      return Math.round(diffInHours * 100) / 100;
    } catch (error) {
      return 8; // Default duration if calculation fails
    }
  };

  // Helper method to format time for saving
  export const formatTimeForSaving = (date) => {
    if (!date) return null;
    return toLocalDateTime(date);
  };

  // Helper method to parse time strings in various formats
  export const  parseTimeString = (timeString) => {
      try {
        // If it's already a Date object, return it
        if (timeString instanceof Date) return timeString;
  
        // If null or undefined, return default time
        if (!timeString) {
          const defaultTime = new Date();
          defaultTime.setHours(9, 0, 0, 0); // Default to 9:00 AM
          return defaultTime;
        }
  
        // Create a new date object for today
        const date = new Date();
  
        // Handle ISO format or contains 'T'
        if (typeof timeString === "string" && timeString.includes("T")) {
          return new Date(timeString);
        }
  
        // Handle "HH:MM:SS" or "HH:MM" format
        if (typeof timeString === "string") {
          const timeParts = timeString.split(":");
          if (timeParts.length >= 2) {
            const hours = parseInt(timeParts[0], 10);
            const minutes = parseInt(timeParts[1], 10);
            const seconds = timeParts.length > 2 ? parseInt(timeParts[2], 10) : 0;
  
            date.setHours(hours, minutes, seconds, 0);
            return date;
          }
        }
  
        // If we couldn't parse it, return the original date
        return date;
      } catch (error) {
        const defaultTime = new Date();
        defaultTime.setHours(9, 0, 0, 0); // Default to 9:00 AM
        return defaultTime;
      }
    };

    // Add this function before handleSave
    export const   generateRecurrenceRule = (
        pattern: number,
        recurEvery: number,
        weekDays: any,
        endDate: Date
      ): string => {
        let rule = "";
    
        switch (pattern) {
          case 1: // Daily
            rule = `FREQ=DAILY;INTERVAL=${recurEvery}`;
            break;
          case 2: // Weekly
            const selectedDays = Object.entries(weekDays)
              .filter(([_, value]) => value)
              .map(([key]) => {
                const dayMap: { [key: string]: string } = {
                  sunday: "SU",
                  monday: "MO",
                  tuesday: "TU",
                  wednesday: "WE",
                  thursday: "TH",
                  friday: "FR",
                  saturday: "SA",
                };
                return dayMap[key];
              });
    
            if (selectedDays.length > 0) {
              rule = `FREQ=WEEKLY;INTERVAL=${recurEvery};BYDAY=${selectedDays.join(
                ","
              )}`;
            }
            break;
          case 3: // Monthly
            rule = `FREQ=MONTHLY;INTERVAL=${recurEvery};BYMONTHDAY=${recurEvery}`;
            break;
        }    
        // Add end date if available
        if (endDate) {
          rule += `;UNTIL=${formatDateToICalendar(endDate)}`;
        }    
        console.log('rule ' + rule);
        return rule;
      };

      const formatDateToICalendar =(endDate) => {
        const utcDate = new Date(Date.UTC(
          endDate.getFullYear(),
          endDate.getMonth(),
          endDate.getDate(),
          23, 59, 59
        ));       
        return utcDate.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
      
      };
  export const isNullCheck = (obj) => {
    return (obj != undefined && obj != null) == true ? true : false;
  }

  // Helper method to format time for display
  export const formatTimeForDisplay = (timeString) => {
    if (!timeString) return "";

    // If it's already a Date object, use it directly
    const timeDate =
      timeString instanceof Date ? timeString : new Date(timeString);

    // Format the time for display
    return timeDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  
// Helper method to format time for display
export const formattingTimeforView = (timeString) => {
  try {
    if (!timeString) return "";

    // If it's already in HH:MM:SS format, parse it
    if (typeof timeString === "string") {
      // Try different formats
      if (timeString.includes(":")) {
        const [hours, minutes, seconds] = timeString
          .split(":")
          .map((part) => parseInt(part, 10));

        // Create a date object with the time
        const date = new Date();
        date.setHours(hours || 0, minutes || 0, seconds || 0);

        // Format the time for display (e.g., "1:30 PM")
        return date.toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
        });
      } else if (timeString.includes("T")) {
        // Handle ISO format
        return new Date(timeString).toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
        });
      }
    }

    // If it's a Date object, format it directly
    if (timeString instanceof Date) {
      return timeString.toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit",
      });
    }

    // Default fallback
    return timeString;
  } catch (error) {
    return timeString || ""; // Return the original value as fallback
  }
};


  

